import { VideoQuiz$1 as VideoQuiz } from '@coursera-web/video-quiz';
import Q from 'q';
import _ from 'underscore';

import videoQuizData from 'pages/open-course/common/data/videoQuizData';

export default function (options: $TSFixMe) {
  const hasAssessment = options.metadata.getDefinition('hasInVideoAssessment');
  const isAuthenticated = options.authenticated;

  if (!hasAssessment || !isAuthenticated) {
    return Q.fcall(_.constant(null));
  }

  return videoQuizData(options)
    .then(function (data: $TSFixMe) {
      return new VideoQuiz(data);
    })
    .catch(function (error: $TSFixMe) {
      return Q.fcall(_.constant(null));
    });
}
